<template>
	<div class="row">
		<div class="col-md-5">
			<div class="card">
				<div class="card-header bg-dark">
					<h3 class="mb-0 text-white">ตั้งค่าแคชแบ็ก</h3>
				</div>
				<div class="card-body">
					<form @submit.prevent="saveSetting" v-if="setting">
						<base-checkbox class="mb-3" v-model="setting.enable">
							เปิดใช้งาน
						</base-checkbox>

						<div class="row">
							<div class="col-md-6">
								<base-input label="แคชแบ็ก" placeholder="0%" v-model="setting.amount" />
							</div>
							<div class="col-md-6">
								<base-input label="แคชแบ็กสูงสุด" placeholder="0" v-model.number="setting.maxAmount" />
							</div>
						</div>

						<div class="row">
							<div class="col-md-6">
								<base-input
									label="ยอดฝากขั้นต่ำ"
									placeholder="ยอดฝากขั้นต่ำ"
									v-model.number="setting.min"
								/>
							</div>
							<div class="col-md-6">
								<base-input
									label="จำนวนเทิร์น"
									placeholder="จำนวนเทิร์น"
									v-model.number="setting.turn"
								/>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6">
								<base-input label="ประเภทถอนสูงสุด">
									<el-select v-model="setting.withdrawLimitType" placeholder="ประเภทถอนสูงสุด">
										<el-option label="จำนวน" value="fixed" />
										<el-option label="ยอดแคชแบ็ค (เท่า)" value="sum" />
									</el-select>
								</base-input>
							</div>
							<div class="col-md-6">
								<base-input
									label="จำนวนถอนสูงสุด"
									placeholder="จำนวนถอนสูงสุด"
									v-model.number="setting.withdrawLimit"
									v-if="setting.withdrawLimitType == 'fixed'"
								/>
								<base-input
									label="ถอนสูงสุด (เท่า)"
									placeholder="ถอนสูงสุด (เท่า)"
									v-model.number="setting.withdrawLimit"
									v-else
								/>
							</div>
						</div>

						<div class="form-group mt-3">
							<label class="form-control-label">เงื่อนไขแคชแบ็ก</label>
							<base-checkbox v-model="setting.rules.noWithdraw" class="mb-2">
								ต้องไม่มีรายการถอน (ตลอดทั้งวัน)
							</base-checkbox>
							<base-checkbox v-model="setting.rules.noBonus" class="mb-2">
								ต้องไม่มีรายรับโบนัส (ตลอดทั้งวัน)
							</base-checkbox>
							<base-checkbox v-model="setting.rules.noWheel" class="mb-2">
								ต้องไม่มีรายการหมุนกงล้อเสี่ยงโชค (ตลอดทั้งวัน)
							</base-checkbox>
							<base-checkbox v-model="setting.rules.minCredit" class="mb-2">
								ต้องมีเครดิตคงน้อยกว่าหรือเท่ากับ {{ minCredit }}
							</base-checkbox>
						</div>

						<base-button native-type="submit" class="mt-2" :disabled="loading">
							บันทึกข้อมูล
						</base-button>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Select, Option } from 'element-ui'
import SettingService from '../services/setting.service'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			minCredit: 0,
			setting: null,
		}
	},
	methods: {
		saveSetting() {
			this.loading = true
			SettingService.saveCashback(this.setting)
				.then(({ message }) => {
					this.$notify({ type: 'success', message })
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	created() {
		SettingService.fetchSetting().then((res) => {
			this.minCredit = res.setting.minCredit
			this.setting = res.setting.cashback
		})
	},
}
</script>
